import { render, staticRenderFns } from "./event-search.vue?vue&type=template&id=7c71c6c0"
import script from "./event-search.vue?vue&type=script&lang=ts"
export * from "./event-search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports